import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, CheckCircle } from 'lucide-react';
import { supabase } from '../../lib/auth';

const MagicPage: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // Vérifier la session
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        // Si pas de session, rediriger vers login
        navigate('/login');
        return;
      }
    };

    checkSession();

    // Démarrer le compte à rebours
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/app');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-gray-100 flex flex-col justify-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-6 sm:py-8 px-4 sm:px-10 shadow-xl rounded-xl border border-gray-200">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="p-3 bg-green-100 rounded-full">
                <CheckCircle className="h-12 w-12 text-green-600" />
              </div>
            </div>
            
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Connexion réussie !
            </h2>
            
            <div className="flex justify-center items-center mb-4">
              <Zap className="h-6 w-6 text-pink-600 mr-2" />
              <span className="text-gray-600">Connexion via lien magique réussie</span>
            </div>
            
            <p className="text-gray-600 mb-6">
              Vous allez être redirigé vers votre dashboard dans{' '}
              <span className="font-semibold text-pink-600">{countdown}</span> seconde{countdown > 1 ? 's' : ''}.
            </p>
            
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
              <div 
                className="bg-pink-600 h-2 rounded-full transition-all duration-1000 ease-linear"
                style={{ width: `${((3 - countdown) / 3) * 100}%` }}
              ></div>
            </div>
            
            <button
              onClick={() => navigate('/app')}
              className="text-pink-600 hover:text-pink-800 text-sm font-medium"
            >
              Accéder maintenant au dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagicPage;